



























































import Vue from "vue";
import { TranslateResult } from 'vue-i18n'
import {auth, functions } from "@/scripts/firebase";
import {ActionLinkParams,NoticeProps } from "@/scripts/datatypes";
import { Component, Mixins  } from "vue-property-decorator";
import { ValidationObserver } from 'vee-validate'

import Notice from "@/components/Notice.vue";
import Common from '../mixins/common';

@Component({
  components: {
    Notice
  }
})

export default class ActionLink extends Mixins(Common) {
  isLoading = false
  showPasswordInput = false;
  showSendPasswordResetEmailButton = false
  password = ''
  email =  ''
  restoredEmail = ''
  actionLinkResult = {} as NoticeProps
  secondActionResult = {} as NoticeProps

  get title(){
    const path = `actionLink.mode.${this.$store.getters.actionLinkMode}`
    let title = ''
    if(this.$store.getters.actionLinkMode){
      return this.$t(`actionLink.mode.${this.$store.getters.actionLinkMode}`) as string
    }else{
      title = this.$t('message.error') as string
      document.title = this.$t('serviceName.marito') + ' ' + title
    }
    return title
  }

  async created(){
    try{
      this.$store.commit("setLoading",true);
      this.isLoading = true

      switch (this.$store.getters.actionLinkMode) {
        case 'resetPassword':
          await this.handleResetPassword();
          break
        case 'recoverEmail':
          await this.handleRecoverEmail();
          break
        case 'verifyEmail':
          await this.handleVerifyEmail();
          break
        case 'verifyAndChangeEmail':
          await this.handleVerifyAndChangeEmail();
          break
        default:
          this.actionLinkResult = {
                message: this.$t('authentication.errorCode.auth/invalid-action-code') as string,
                isShow: true,
                duration: 0,
                type: {'is-danger': true}
              }
          }
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      this.actionLinkResult = {
        message: this.$getErrorMessage(errorCode,'authentication.errorCode.auth/invalid-action-code'),
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  private async handleRecoverEmail() {
    const info = await auth.checkActionCode(this.$store.getters.actionLinkCode)
    this.restoredEmail = info.data.email as string

    // Revert to the old email.
    await auth.applyActionCode(this.$store.getters.actionLinkCode)
    // Account email reverted to restoredEmail

    this.actionLinkResult = {
      message: this.$t('actionLink.recoverdEmail') as string,
      isShow: true,
      duration: 0,
      type: {'is-info': true}
    }

    this.showSendPasswordResetEmailButton = true
  }

  async sendPasswordResetEmail(){
    try{
      this.$store.commit("setLoading",true);
      this.isLoading = true
      
      await auth.sendPasswordResetEmail(this.restoredEmail)
      this.secondActionResult = {
        message: this.$t('resetPassword.sendEmail') as string,
        isShow: true,
        duration: 0,
        type: {'is-info': true}
      }
    }catch(error) {
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      this.secondActionResult = {
        message: this.$getErrorMessage(errorCode),
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  private async handleResetPassword() {
    this.email = await auth.verifyPasswordResetCode(this.$store.getters.actionLinkCode)
    this.showPasswordInput = true
  }

  public async resetPassword(){
    const observer = this.$refs.resetPasswordValidationObserver as InstanceType<typeof ValidationObserver>;

    try{
      this.secondActionResult = {}
    
      if(await observer.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        await auth.confirmPasswordReset(this.$store.getters.actionLinkCode, this.password)
        this.secondActionResult = {
          message: this.$t('actionLink.completesPasswordReset') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }
        /** 
         * await auth.signInWithEmailAndPassword(this.actionParams.email, this.password);
         * ダッシュボードへ
         * this.$router.push('/settings');
         * 
         */
       
        this.password = ''
        observer.reset()
      }
    }catch(error) {
      console.table(error);
      const errorCode = this.$getErrorCode(error)
      const message = this.$getErrorMessage(errorCode,'authentication.errorCode.auth/invalid-action-code')
      const errorField = this.$getErrorField(errorCode)

      if(message && errorField){        
        observer.setErrors({
         [errorField]: message
        })
      }

      this.secondActionResult = {
        message: message,
        isShow: true,
        type: {'is-danger': true}
      }

    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  async handleVerifyEmail(){
    await auth.applyActionCode(this.$store.getters.actionLinkCode)
    this.actionLinkResult = {
      message: this.$t('actionLink.verifiedEmail') as string,
      isShow: true,
      duration: 0,
      type: {'is-success': true}
    }
  }

   async handleVerifyAndChangeEmail(){
    await auth.applyActionCode(this.$store.getters.actionLinkCode)
    this.actionLinkResult = {
      message: this.$t('actionLink.verifiedAndChangedEmail') as string,
      isShow: true,
      duration: 0,
      type: {'is-success': true}
    }
  }

}
